<template>
  <v-card class="pa-4 mb-4">
    <div class="text-subtitle-1 font-weight-medium mb-3">
      {{ $t("acceptance.parties.title") }}
    </div>
    <v-row dense>
      <v-col cols="12" md="6">
        <div class="text-caption text-grey-darken-1">
          {{ $t("acceptance.owner.title") }}
        </div>
        <div class="text-body-1">{{ ownerText }}</div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="text-caption text-grey-darken-1">
          {{ $t("acceptance.deliverer.title") }}
        </div>
        <div class="text-body-1">{{ delivererText }}</div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
// Read-only owner and deliverer of a confirmed acceptance in the PRA layout (decision Q2). Edits
// and corrections stay in the full parties card under "Mostra dettagli".
export default {
  name: "AcceptanceOwnerCompact",
  props: {
    dossier: { type: Object, required: true },
  },
  computed: {
    ownerText() {
      const owner = this.dossier.owner || {};
      return [owner.name, owner.taxCode].filter(Boolean).join(" · ") || "—";
    },
    delivererText() {
      const deliverer = this.dossier.deliverer || {};
      const document = deliverer.idDocument || {};
      const documentText = [
        document.type
          ? this.$t(`acceptance.id_document_types.${document.type}`)
          : "",
        document.number,
      ]
        .filter(Boolean)
        .join(" ");
      return [deliverer.name, documentText].filter(Boolean).join(" · ") || "—";
    },
  },
};
</script>
